import { Component, OnInit, Input, SimpleChanges, ViewChild, forwardRef } from '@angular/core';
import { 
    IonGrid, IonRow, IonCol, IonLabel, IonSpinner, InfiniteScrollCustomEvent, IonInfiniteScroll,  IonInfiniteScrollContent 
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import moment from 'moment';

import { MarvCircleComponent, MarvProgressBarComponent, MarvMessageComponent, MarvDrawerComponent } from '@marv/components';
import { MarvDateService } from '@marv/services';
import { MissionItem, MissionItemComponent, MissionDetailsComponent } from '@app/components';
import { MissionStatus, MissionPlanningFilters } from '@app/models';
import { OrderService, OperationService } from '@app/services';

@Component({
    selector: 'app-mission-within-five-days',
    templateUrl: './within-five-days.component.html',
    styleUrls: ['./within-five-days.component.scss'],
    imports: [
        IonGrid, IonRow, IonCol, IonLabel, IonInfiniteScroll, IonInfiniteScrollContent, IonSpinner, TranslatePipe, 
        forwardRef(() => MarvCircleComponent), forwardRef(() => MarvProgressBarComponent), forwardRef(() => MarvMessageComponent), 
        forwardRef(() => MarvDrawerComponent), 
        forwardRef(() => MissionItemComponent), forwardRef(() => MissionDetailsComponent)
    ]
})
export class MissionWithinFiveDaysComponent  implements OnInit {

    @Input({alias : 'typesMissions', required : false}) typesMissions: Array<string> = [];

    @ViewChild('drawerMissionDetails') drawerMissionDetails: MarvDrawerComponent;

    isFetching: boolean = false;
    missionsItems: Array<MissionItem> = [];
    missionsItemsToDisplay: Array<MissionItem> = [];
    missionsItemsDisplayed: Array<MissionItem> = [];    
    nbMissionsValidated: number = 0;
    nbMissionsAffected: number = 0;
    maxMissionsDisplayed: number = 50;
    indexMissionDisplayed: number = 0;
    disabledInfiniteScroll: boolean = false;
    
    missionItemSelected: MissionItem|null = null; 
    
    constructor(
        private orderService: OrderService
    ) { }

    async ngOnInit() {
        await this.loadsMissions();
    }
    
    ngOnChanges(changes: SimpleChanges) {
        if(changes['typesMissions']){
            this.setMissionsToDisplay();
        }
    }
    
    async loadsMissions(){
        this.isFetching = true;
        let startDate = MarvDateService.FromDate(moment().add(1, 'days').toDate());
        let endDate = MarvDateService.FromDate(moment().add(6, 'days').toDate());        
        if(startDate && endDate){
            let filters: MissionPlanningFilters = {
                from: startDate,
                to: endDate
            };
            let report = await this.orderService.loadPlanning(filters);
            if(report){            
                this.missionsItems = report.getMissionsItems(OperationService.OperationsSettings);           
                this.setMissionsToDisplay();
            }
        }
        this.isFetching = false;
    }
    
    setMissionsToDisplay(){
        if(this.typesMissions.length > 0){
            this.missionsItemsToDisplay = this.missionsItems.filter(m => 
                (m.operation && this.typesMissions.indexOf(m.operation?.typeOfMission) !== -1)
            );
        }
        else{
            this.missionsItemsToDisplay = this.missionsItems;
        }
        this.nbMissionsValidated = this.missionsItemsToDisplay.filter(m => [MissionStatus.Status.ASSIGNED, MissionStatus.Status.VALIDATED].indexOf(m.status.code) !== -1).length;
        this.nbMissionsAffected = this.missionsItemsToDisplay.filter(m => m.status.code === MissionStatus.Status.ASSIGNED).length;
        this.missionsItemsDisplayed = [];
        this.indexMissionDisplayed = 0;
        this.disabledInfiniteScroll = false;
        this.getMissionsDisplayed();
    }
        
    getMissionsDisplayed() {
        let subArray = this.missionsItemsToDisplay.slice(this.indexMissionDisplayed, this.indexMissionDisplayed+this.maxMissionsDisplayed);
        if(subArray.length > 0){
            this.missionsItemsDisplayed = this.missionsItemsDisplayed.concat(subArray);
            this.indexMissionDisplayed += subArray.length;
        }
        else{
            this.disabledInfiniteScroll = true;
        }
    }
    
    onIonInfinite(event: InfiniteScrollCustomEvent) {        
        this.getMissionsDisplayed();
        event.target.complete();
    }
    
    onSelectMission(missionItem: MissionItem){
        this.missionItemSelected = missionItem;
        this.drawerMissionDetails.open();
    }

    onDidDismissDrawerMission($event: any){
        this.missionItemSelected = null;
    }
    
    async onUpdateMission(status: boolean){   
        if(status){ 
            await this.loadsMissions(); 
        }       
    }
    
    async onDeleteMission(status: boolean){
        if(status){
            this.drawerMissionDetails.close();
            await this.loadsMissions();
        }
    }
}
